module.exports = __webpack_public_path__ + "img/acaki19.6f7051ae.jpg";